const __WEBPACK_NAMESPACE_OBJECT__ = require("spark-md5");